import { ReactNode } from 'react';

export default function Tag(tagProps: TagProps): JSX.Element {
  const {
    icon,
    text,
    textColor = '',
    showBorder = false,
    borderColor = '',
    backgroundColor = '',
    additionalCssProps = {},
  } = tagProps;

  let cssProps: React.CSSProperties = {
    color: textColor,
    backgroundColor,
  };

  if (showBorder) {
    cssProps['borderWidth'] = '1px 1px 1px 1px';
    cssProps['borderStyle'] = 'solid';
    cssProps['borderColor'] = borderColor;
  }

  if (Object.keys(additionalCssProps).length > 0) {
    cssProps = { ...cssProps, ...additionalCssProps };
  }

  return (
    <div
      style={cssProps}
      className={`flex items-center space-x-8 px-8 py-4 font-700 rounded-8`}
    >
      {!!icon ? <>{icon}</> : null}
      <p className="font-700 uppercase text-10 truncate">{text}</p>
    </div>
  );
}

type TagProps = {
  icon?: ReactNode;
  text: string;
  textColor?: string;
  backgroundColor?: string;
  showBorder?: boolean;
  borderColor?: string;
  additionalCssProps?: React.CSSProperties;
};
